import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

interface IRowProps {
  className?: string;
  wrap?: boolean;
  align?: 'top' | 'middle' | 'bottom';
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
}

const ALIGN_CLASS = {
  top: 'start',
  middle: 'center',
  bottom: 'end',
};

const JUSTIFY_CLASS = {
  start: 'start',
  end: 'end',
  center: 'center',
  'space-around': 'around',
  'space-between': 'between',
};

const Row: FC<PropsWithChildren<IRowProps>> = ({ children, className = '', wrap = true, align = 'top', justify = 'start' }) => {
  const rootClass = classNames('ink-row', className, {
    'ink-row--wrap': wrap,
    [`ink-row__align--${ALIGN_CLASS[align]}`]: align,
    [`ink-row__justify--${JUSTIFY_CLASS[justify]}`]: justify,
  });

  return <View className={rootClass}>{children}</View>;
};

export default Row;
